import React, { memo, useEffect, useState } from 'react'
import { connect } from 'react-redux'

import { actualizarEstadoSilos } from '../../actions'
import { AbmMovimientosView } from '../components/AbmMovimientosView'

export const AbmMovimientos = connect(null, { actualizarEstadoSilos })(
  memo(({ actualizarEstadoSilos }) => {
    const [intervalSubscription, setIntervalSubscription] = useState(null)
    useEffect(() => {
      if (intervalSubscription === null) {
        actualizarEstadoSilos()
        // Agregar filtros
        setIntervalSubscription(setInterval(() => actualizarEstadoSilos(), (5 * 1000 * 60)))
      } else {
        return () => clearInterval(intervalSubscription)
      }
    }, [actualizarEstadoSilos, intervalSubscription])
    return <AbmMovimientosView />
  })
)
